module.exports = __webpack_public_path__ + "static/media/unblur.2e4cb342.svg";